<template>
  <v-container class="py-8 px-10">
    <!-- Título principal -->
    <div class="text-h4 font-weight-bold mb-1">Dashboard de control</div>
    <div class="text-subtitle-1 mb-6">
      Aquí puedes ver un resumen de la actividad reciente de credito revolvente.
    </div>

    <v-row
      v-for="currencyItem in dashboard.byCurrency"
      :key="currencyItem.currency"
      class="mb-6 no-gutters"
      elevation="4"
      style="border: 1px solid #e0e0e0; border-radius: 20px;"
      >
      <!-- GMV principal -->
      <v-col cols="12" md="3">
        <v-card
          elevation="6"
          class="pa-6 text-center d-flex flex-column align-center justify-center white--text"
          style="
            border-top-left-radius: 20px;
            border-bottom-left-radius: 20px;
            height: 100%;
            background: linear-gradient(135deg, #1e3a8a, #3b82f6);
            margin-right: -1px; /* para unir sin espacio */
            z-index: 2;
          "
        >
          <v-icon large class="mb-2 white--text">mdi-cash-multiple</v-icon>
          <div style="font-family: 'montserrat-bold'; font-size: 24px;">${{ formatMoney(currencyItem.revenue) }} {{ currencyItem.currency }}</div>
          <div style="font-family: 'montserrat-bold';" class="white--text">Revenue</div>
        </v-card>
      </v-col>

      <!-- Grupo de KPIs secundarios -->
      <v-col cols="12" md="9">
        <v-row no-gutters style="height: 100%;">
          <!-- Pendientes de cesión -->
          <v-col cols="4">
            <v-card
              outlined
              class="pa-4 text-center d-flex flex-column align-center justify-center"
              style="border-radius: 0; border-left: none; height: 100%;"
            >
              <div style="font-family: 'montserrat-bold'; font-size: 20px;">${{ formatMoney(currencyItem.totalFinanced) }} {{ currencyItem.currency }}</div>
              <div style="font-family: 'montserrat-bold';" class="grey--text text--darken-1">Monto financiado</div>
            </v-card>
          </v-col>

          <!-- Por cobrar -->
          <v-col cols="4">
            <v-card
              outlined
              class="pa-4 text-center d-flex flex-column align-center justify-center"
              style="border-radius: 0; border-left: none; height: 100%;"
            >
              <div style="font-family: 'montserrat-bold'; font-size: 20px;">${{ formatMoney(currencyItem.totalCollected) }} {{ currencyItem.currency }}</div>
              <div style="font-family: 'montserrat-bold';" class="grey--text text--darken-1">Monto cobrado</div>
            </v-card>
          </v-col>

          <!-- Monto financiado -->
          <v-col cols="4">
            <v-card
              outlined
              class="pa-4 text-center d-flex flex-column align-center justify-center"
              style="border-top-right-radius: 20px; border-bottom-right-radius: 20px; border-left: none; height: 100%;"
            >
              <div style="font-family: 'montserrat-bold'; font-size: 20px;">${{ formatMoney(currencyItem.totalFinanced - currencyItem.totalCollected + currencyItem.revenue) }} {{ currencyItem.currency }}</div>
              <div style="font-family: 'montserrat-bold';" class="grey--text text--darken-1">Monto por cobrar</div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      dashboard: [],
    }
  },
  computed: {
  },
  methods: {
    async getDashboard() {
      try {
        const response = await DB.get(`${URI}/api/v1/en/admin/credit/dashboard`, {
          headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
          }
        })
        this.dashboard = response.data.dashboard;
      } catch (err) {
        console.error(err)
      }
    },
    formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
  },
  mounted() {
    this.getDashboard();
  }
}
</script>

<style scoped>
.gradient-card {
  background: linear-gradient(to bottom, #333, #000);
  border-radius: 12px;
  color: white;
}
</style>
